import * as atlas from 'azure-maps-control';
import { Marker } from '../markers/Marker';

export interface ClusterProperties extends Record<string, atlas.AggregateExpression> {
  point_count: atlas.AggregateExpression;
  point_count_abbreviated: atlas.AggregateExpression;
}

export abstract class ClusterLayer<M extends Marker> {
  get options(): atlas.SymbolLayerOptions {
    return {
      filter: ['has', 'point_count'], // Only show for clusters
      iconOptions: {
        image: 'marker-blue',
        size: 1.5,
      },
      textOptions: {
        color: 'white',
        size: 14,
        font: ['StandardFont-Bold'],
        offset: [0, -2.03],
      },
    };
  }

  get clusterProperties() {
    return {
      ids: ['concat', ['concat', ['get', 'id'], '::']],
    };
  }

  popupBuilder?: (props: ClusterProperties, markers: M[]) => React.ReactNode;
}
